import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

const INK = "#0A0A0A";
const CORAL = "#FF5C5C";
const TINT = "#FAECE7";
const SERIF = "'Instrument Serif', 'Times New Roman', Georgia, serif";
const SANS = "'Work Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export function SeoPageShell({
  eyebrow,
  h1,
  intro,
  children,
}: {
  eyebrow: string;
  h1: string;
  intro: string;
  children: ReactNode;
}) {
  return (
    <div style={{ minHeight: "100vh", background: "#fff", color: INK, fontFamily: SANS }}>
      <header style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "20px 24px", borderBottom: "0.5px solid rgba(10,10,10,0.05)" }}>
        <Link to="/" style={{ color: CORAL, fontWeight: 600, fontSize: 20, letterSpacing: "-0.5px", textDecoration: "none" }}>
          Like2Fit
        </Link>
        <Link to="/" style={{ background: CORAL, color: "#fff", textDecoration: "none", borderRadius: 999, padding: "8px 16px", fontSize: 13, fontWeight: 600 }}>
          Try free
        </Link>
      </header>

      <main style={{ maxWidth: 720, margin: "0 auto", padding: "48px 24px 24px" }}>
        <p style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.25em", color: CORAL, margin: "0 0 16px" }}>
          {eyebrow}
        </p>
        <h1 style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 44, lineHeight: 1.1, margin: 0, letterSpacing: "-0.5px" }}>
          {h1}
        </h1>
        <p style={{ marginTop: 20, fontSize: 18, lineHeight: 1.6, color: "rgba(10,10,10,0.7)" }}>
          {intro}
        </p>

        <article style={{ marginTop: 40, fontSize: 16, lineHeight: 1.7, color: "rgba(10,10,10,0.85)" }}>
          {children}
        </article>

        <section style={{ marginTop: 56, padding: "32px 24px", background: TINT, borderRadius: 20, textAlign: "center" }}>
          <p style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 28, margin: "0 0 20px", color: INK }}>
            Ready to shop any outfit you see?
          </p>
          <Link to="/" style={{ display: "inline-block", background: CORAL, color: "#fff", padding: "14px 28px", borderRadius: 999, fontSize: 15, fontWeight: 600, textDecoration: "none" }}>
            Open the AI outfit finder
          </Link>
        </section>
      </main>

      <footer style={{ background: "#fff", padding: "32px 24px", borderTop: "0.5px solid rgba(10,10,10,0.06)" }}>
        <nav aria-label="Site footer" style={{ display: "flex", flexWrap: "wrap", gap: "12px 20px", justifyContent: "center", fontSize: 13 }}>
          <Link to="/" style={{ color: "rgba(10,10,10,0.7)", textDecoration: "none" }}>Home</Link>
          <Link to="/how-it-works" style={{ color: "rgba(10,10,10,0.7)", textDecoration: "none" }}>How it works</Link>
          <Link to="/shop-the-look" style={{ color: "rgba(10,10,10,0.7)", textDecoration: "none" }}>Shop the look</Link>
          <Link to="/style-my-wardrobe" style={{ color: "rgba(10,10,10,0.7)", textDecoration: "none" }}>Style my wardrobe</Link>
          <Link to="/faq" style={{ color: "rgba(10,10,10,0.7)", textDecoration: "none" }}>FAQ</Link>
          <Link to="/about" style={{ color: "rgba(10,10,10,0.7)", textDecoration: "none" }}>About</Link>
          <Link to="/privacy" style={{ color: "rgba(10,10,10,0.7)", textDecoration: "none" }}>Privacy</Link>
          <Link to="/terms" style={{ color: "rgba(10,10,10,0.7)", textDecoration: "none" }}>Terms</Link>
          <Link to="/delete-account" style={{ color: "rgba(10,10,10,0.7)", textDecoration: "none" }}>Delete Account</Link>
        </nav>
      </footer>
    </div>
  );
}

export function H2({ children }: { children: ReactNode }) {
  return <h2 style={{ fontFamily: SERIF, fontSize: 28, margin: "40px 0 12px", letterSpacing: "-0.3px", color: INK }}>{children}</h2>;
}
